import { render } from "./SkinProfileFormInput.vue?vue&type=template&id=16b8d48e&scoped=true&bindings={\"modelValue\":\"props\",\"label\":\"props\",\"onInputMessage\":\"options\"}"
import script from "./SkinProfileFormInput.vue?vue&type=script&lang=js"
export * from "./SkinProfileFormInput.vue?vue&type=script&lang=js"

import "./SkinProfileFormInput.vue?vue&type=style&index=0&id=16b8d48e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-16b8d48e"

export default script